module.exports = __webpack_public_path__ + "img/favicon.b9f45b7.png";